import React from 'react';
import PropTypes from 'prop-types';

import PopupV2 from '../../../../Popup/PopupV2';
import styles from '../../collegeProspectTab.scss';

const TESTID_PREFIX = 'modal.profile.college-prospect.primary-contact-info';

const PrimaryContactInfoModal = ({ onClose }) => (
    <PopupV2
        onCloseClick={onClose}
        config={{
            size: 'fullScreenOnMobile',
            customWidth: 400,
            customHeader: () => null,
        }}
    >
        <div
            className={styles.primaryContactInfoModal}
            data-testid={`${TESTID_PREFIX}.container`}
        >
            <div
                className={styles.primaryContactInfoTitle}
                data-testid={`${TESTID_PREFIX}.title`}
            >
                About Primary Contact
            </div>
            <p
                className={styles.primaryContactInfoBody}
                data-testid={`${TESTID_PREFIX}.body`}
            >
                College coaches will use this contact info to reach out about
                recruiting. We recommend a parent, guardian, or coach
                {' '}— someone who can manage outreach on the player&apos;s
                behalf. For players under 18, a parent or guardian is strongly
                recommended.
            </p>
            <div className={styles.primaryContactInfoActions}>
                <button
                    type="button"
                    className={styles.primaryContactInfoCloseBtn}
                    onClick={onClose}
                    data-testid={`${TESTID_PREFIX}.close-btn`}
                >
                    CLOSE
                </button>
            </div>
        </div>
    </PopupV2>
);

PrimaryContactInfoModal.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default PrimaryContactInfoModal;
